// Google Tag Manager dataLayer (container loaded in app.blade.php). GA4 events are configured in GTM.

type DataLayerValue = string | number | boolean | null;

declare global {
    interface Window {
        dataLayer?: Record<string, unknown>[];
    }
}

/**
 * Pushes a custom event to the dataLayer. No-op on the server (SSR). Never send personal data here.
 */
export function pushDataLayerEvent(event: string, params: Record<string, DataLayerValue> = {}): void {
    if (typeof window === 'undefined') return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
}
